import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

/* Config */

/* Components */
import { Banner, Container } from "../../utils/components/Common";
import { WorkspaceJumbotron } from "./Workspace.elements";
import ParticipantListPanel from "../participant/ParticipantList";
import ClinicianListPanel from "../clinician/ClinicianList";
import PaymentListPanel from "../payments/PaymentList";

/* APIs - Hooks - Utils */
import { useAppSelector } from "../../app/hooks";

const Workspace = (): JSX.Element => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const user = useAppSelector((state) => state.user.user);

  return (
    <>
      {user && isLoggedIn ? (
        <WorkspaceJumbotron user={user} isLoggedIn={isLoggedIn}>
          <Tabs>
            <Container padding="px-16 py-6">
              <TabList>
                <Tab>Participants</Tab>
                <Tab>Clinicians</Tab>
                <Tab>Payments</Tab>
              </TabList>
            </Container>
            <TabPanel>
              <ParticipantListPanel user={user} isLoggedIn={isLoggedIn} />
            </TabPanel>
            <TabPanel>
              <ClinicianListPanel isLoggedIn={isLoggedIn} />
            </TabPanel>
            <TabPanel>
              {/* TODO: Provision Payment List Panel similar to Clinician and Participant */}
              <PaymentListPanel user={user} isLoggedIn={isLoggedIn} />
            </TabPanel>
          </Tabs>
        </WorkspaceJumbotron>
      ) : (
        <Banner
          heading="Protected Route"
          message="This is a protected route. Authentication required."
        />
      )}
    </>
  );
};

export default Workspace;
